module.exports = __webpack_public_path__ + "img/13_18.e327a1d9.png";